import { CommonContentPageTranslator } from 'src/translators'
import { useGetCommonPagesQuery } from 'src/types/generated'

export const useGetCommonContentPages = () => {
  const { loading, data, error, refetch } = useGetCommonPagesQuery()

  return {
    loading,
    commonContentPages:
      data && data.commonPages ? CommonContentPageTranslator.toEntities(data.commonPages) : [],
    error,
    refetch,
  }
}
